<template>
<v-app>
  <v-toolbar app flat>
    <a @click="$router.push('/')">
      <v-avatar tile>
        <img :src="require('./assets/Logo.png')" />
      </v-avatar>
    </a>
    <v-toolbar-title class="headline text-uppercase hidden-sm-and-down" >
      <a @click="$router.push('/')">
        <h1>Shayofae</h1>
      </a>
    </v-toolbar-title>

    <v-spacer></v-spacer>
    <v-btn v-if=" getLang()==='fr' " flat @click="$router.push('/'); $router.push('actuality/' + getLang())" class="hidden-sm-and-down">
      <span class="mr-2">{{$t('ACTUALITY')}}</span>
    </v-btn>
    <v-btn flat @click="$router.push('/'); $router.push('legalnotice/' + getLang())" class="hidden-sm-and-down">
      <span class="mr-2">{{$t('LEGALNOTICE')}}</span>
    </v-btn>
    <v-btn flat @click="$router.push('/'); $router.push('privatePolicy/' + getLang())" class="hidden-sm-and-down">
      <span class="mr-2">{{$t('PRIVATEPOLICY')}}</span>
    </v-btn>
    <v-btn flat class="hidden-md-and-up" v-slot:activator="{ on }" v-on="on">
      <v-icon>toc</v-icon>
    </v-btn>
    <v-menu offset-y>
      <template v-slot:activator="{ on }" class="hidden-md-and-up">
        <v-btn flat v-on="on">
          <v-icon>toc</v-icon>
        </v-btn>
      </template>
      <v-list>
        <v-list-tile v-for="(item, index) in items" :key="index" @click="$router.push('/'); $router.push(item.link+'/' + getLang())">
          <v-list-tile-title>{{ item.title }}</v-list-tile-title>
        </v-list-tile>
      </v-list>
    </v-menu>
  </v-toolbar>

  <Home />

  <router-view />
  <div class="stuck hidden-sm-and-down">
    <div v-for="link in links" dark :to="link.link" size=20>
      <v-card>
        <v-card-title>
          <a :href="link.link">
            <img :src="link.img" style="size: 10%;" />
          </a>
        </v-card-title>
      </v-card>
    </div>
  </div>
  <div class="hidden-md-and-up">
    <v-layout row>
    <div v-for="link in links" dark :to="link.link" size=20>
      <v-card flat style="background-color: #fafafa">
        <v-card-title>
          <a :href="link.link">
            <img :src="link.img" style="max-width: 3.3em;" />
          </a>
        </v-card-title>
      </v-card>
    </div>
  </v-layout>
  </div>
  <Footer />
</v-app>
</template>

<script>
import Footer from './views/Footer'
import Home from './views/Home'

export default {
  components: {
    Home,
    Footer,
  },
  name: 'App',
  data() {
    return {
      items: [{
          title: this.$t('LEGALNOTICE'),
          link: 'legalnotice'
        },
        {
          title: this.$t('PRIVATEPOLICY'),
          link: 'privatePolicy'
        },

      ],
      snack: true,
      links: [{
        link: 'https://play.google.com/store/apps/details?id=com.betadigitis.ShayofaeLite',
        img: require('../public/img/gp.png')
      }, {
        link: 'https://www.facebook.com/Betadigitis-279787056068567',
        img: require('../public/img/facebook-logo.png')
      }, {
        link: 'https://www.linkedin.com/company/28131871',
        img: require('../public/img/logo-LinkedIn.png')
      }, {
        link: 'https://twitter.com/shayofae',
        img: require('../public/img/logo-twitter.png')
      }, {
        link: '/#contacts',
        img: require('../public/img/logo-email.png')
      }]
    }
  },
  methods: {
    getLang() {
      return navigator.language.slice(0, 2)
    }
  }
}
</script>

<style scoped>
.stuck {
  text-align: center;
  position: fixed;
  top: 100px;
  right: 10px;
}

a {
  text-decoration: none;
  color: black;
}

h1 {
  padding: 5px;
  text-transform: none;
}

img {
  max-width: 5em;
  height: auto;
}
</style>
